import { AdminModalProps } from './admin-modal-props';
import React from 'react';
import { Surface } from '@mint/ui';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: calc(100vw - 20px);
  /* min-height: 180px; */
  padding: 1rem 0;
  width: 440px;
`;

export const AdminModal: React.FunctionComponent<AdminModalProps> = ({
  children,
  ...rest
}) => {
  return (
    <Surface z={20} {...rest}>
      <Wrapper>{children}</Wrapper>
    </Surface>
  );
};
